module.exports = __webpack_public_path__ + "img/holiday-1.ebd20f60.svg";